
import { LoginModule } from './login/login.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuard } from './_guards/auth.guard';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment'; // Angular CLI environment

import { TokenInterceptorService } from './_helpers/token-interceptor/token-interceptor.service';
import { TokenErrorInterceptorService } from './_helpers/token-interceptor/token-error-interceptor.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigurationModule } from './_config/configuration.module';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { TemplateModule } from './_template/template.module';
import { RouterModule, PreloadAllModules , ExtraOptions } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './_theme/components/shared.module';

import 'hammerjs';
import { appReducer } from './_reducers/app.reducers';


const routerOptions: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    useHash: true,
    relativeLinkResolution: 'legacy'
};

@NgModule({
  declarations: [
    AppComponent,
  ],
  exports: [],
  imports: [
   // DialogsModule,
    SharedModule,
    BrowserModule,
    StoreModule.forRoot( appReducer) ,
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),

    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PerfectScrollbarModule,
    // RouterModule.forRoot(routes, routerOptions ),
    TemplateModule,
    LoginModule,
    ConfigurationModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [ HttpClient ]
      }
    }),
   // InputsModule,
   // DateInputsModule,
   // GridModule,
   // ExcelModule,
    ReactiveFormsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [AuthGuard,
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService,  multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TokenErrorInterceptorService,  multi: true }
],
  bootstrap: [AppComponent]
})
export class AppModule { }
